import React from 'react';
import { useQuery } from 'react-query';
import Loading from '../Loading/Loading';

const CampaignDetails = (props) => {
    const { campaignId } = props;


    const { data, isLoading } = useQuery("campaignDetails", () => fetch(`${process.env.REACT_APP_SECRET_API}/campaign/${campaignId}`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )

    if (isLoading) {
        return <Loading></Loading>
    }

    const details = data.data
    console.log(details)
    return (
        <div className=' relative w-full bg-yellow-900'>
            <div className="relative z-10 text-center py-24 md:py-48">
                <h1 className="text-white text-center text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-display font-bold mb-12">{details?.name}</h1>
                <p className="text-white text-center w-2/3 mx-auto md:text-4xl lg:text-sm font-display font-normal mb-12">{details?.description}</p>
            </div>

            <img src={details?.banner?.original_url} alt="" className="w-full h-full absolute inset-0 object-fit opacity-70"/>


        </div>
    );
};

export default CampaignDetails;